<template>
	<div id="app" class="content">
		<router-view />
		<!-- v-if="isShow" -->
		<!-- <div class="float-cont" id="J_Player">
		</div> -->
	</div>
</template>
<script>
	export default {
		name: 'App',
		data() {
			return {}
		},
		created() {
			//在页面加载时读取sessionStorage里的状态信息
			if (localStorage.getItem("store")) {
				this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))))
			}
			//在页面刷新时将vuex里的信息保存到sessionStorage里
			window.addEventListener("beforeunload", () => {
				localStorage.setItem("store", JSON.stringify(this.$store.state))
			})
			localStorage.removeItem('couponSes');
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style>
	body {
		margin: 0px;
	}

	html,
	body {
		height: 100%;
	}

	#app {
		height: 100%;
		min-height: 100%;
	}
	
	.prism-button-orange {
	  display: none !important;
	}
	.prism-center {
	  display: none !important;
	}
	
	.quality-components {
	  height: auto !important;
	  margin-top: 10px !important;
	}
	.rate-components {
	  height: auto !important;
	  margin-top: 10px !important;
	}
</style>
<style scoped>
	.float-cont {
		width: 500px;
		height: 300px;
		background: black;
		position: fixed;
		right: 150px;
		bottom: 50px;
		z-index: 6666;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue